import React from 'react';

interface OrderIdBadgeProps {
  orderNumber?: string | null;
  id?: string | number;
  compact?: boolean;
  className?: string;
}

const OrderIdBadge: React.FC<OrderIdBadgeProps> = ({ orderNumber, id, compact = false, className = '' }) => {
  const text = `#${orderNumber || id || ''}`;
  if (compact) {
    return (
      <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 ${className}`}>
        {text}
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-md text-sm font-medium bg-blue-50 text-blue-700 border border-blue-100 ${className}`}>
      {text}
    </span>
  );
};

export default OrderIdBadge;

